import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from '@angular/core';
import { CmsProductReferencesComponent, OccEndpointsService, Product, UrlModule } from '@spartacus/core';
import { Observable, Subscription, combineLatest, of } from 'rxjs';
import { distinctUntilChanged, filter, map, switchMap, withLatestFrom } from 'rxjs/operators';
import { CarouselModule, CmsComponentData, CurrentProductService, MediaModule } from "@spartacus/storefront";
import { ActiveCartFacade } from '@spartacus/cart/base/root';
import { HttpClient } from '@angular/common/http';
import { normalizeSlug } from '../../../shared/helpers/slug.helper';
import { isEmpty } from "../../cart/core/utils/utils";
import { GenBaseStoreService } from 'src/app/generac/services/base-store.service';
import { GaItem, GenGoogleAnalyticsService } from 'src/app/generac/services/google-analytics.service';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { GenProductCarouselItemComponent } from '../product-carousel/product-carousel-item/product-carousel-item.component';
import { isEqual } from 'src/app/generac/shared/helpers/is-equal';

@Component({
  selector: 'gen-product-suggestions',
  templateUrl: './product-suggestions.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CommonModule,
    CarouselModule,
    MediaModule,
    GenProductCarouselItemComponent,
    RouterModule,
    UrlModule,
  ],
})
export class GenProductSuggestionsComponent {
  tooltipMessage: string;
  phoneOrEmail: string;
  gaListName: string;
  gaItems: GaItem[] = [];

  private subscription = new Subscription();

  constructor(
    protected cmsComponentData: CmsComponentData<any>,
    protected currentProductService: CurrentProductService,
    protected googleAnalyticsService: GenGoogleAnalyticsService,
    private baseStoreService: GenBaseStoreService,
    private cdr: ChangeDetectorRef,
    private activeCartFacade: ActiveCartFacade,
    private occEndpoints: OccEndpointsService,
    private http: HttpClient,
  ) {
    this.subscription.add(
      combineLatest([
        this.baseStoreService.getTooltipMessage(),
        this.baseStoreService.getPhoneNumber()
      ]).subscribe(([messsage, phoneOrEmail]) => {
        this.tooltipMessage = messsage?.message;
        this.phoneOrEmail = phoneOrEmail?.contactInfo;
        this.cdr.markForCheck();
      })
    );
  }

  protected get componentData$(): Observable<CmsProductReferencesComponent> {
    return this.cmsComponentData.data$.pipe(filter((data) => Boolean(data)));
  }

  /**
   * Returns an Observable String for the title
   */
  get title$(): Observable<string | undefined> {
    return this.componentData$.pipe(map((data) => data?.title));
  }

  /**
   * Observable with an Array of Observables. This is done so that
   * the component UI could consider to lazy load the UI components when they're
   * in the viewpoint.
   */
  items$: Observable<Product | any> = this.activeCartFacade.takeActive()
    .pipe(
      filter(cart => !isEmpty(cart)),
      distinctUntilChanged(),
      switchMap(cart => this.http.get(`${this.occEndpoints.getBaseUrl()}/users/current/carts/${cart.code}/suggestions`)
        .pipe(
          distinctUntilChanged(),
          withLatestFrom(this.title$),
          map(([suggestions, title]) => {
            const products = (suggestions as any)?.products;
            this.gaListName = title;

            if (products?.length > 0) {
              this.googleAnalyticsService.sendViewItemListEvent(products, this.gaListName);
            }

            return products?.map((pr: any) => {
              const product = pr.images?.find((i: any) => i.format === 'product');
              const thumbnail = pr.images?.find((i: any) => i.format === 'thumbnail');

              pr.images = {
                PRIMARY: {
                  product,
                  thumbnail
                }
              };
              return of({ ...pr, routerLink: `/product/${pr.code}/${normalizeSlug(pr.name)}` });
            });
          })
        )
      ),
    )
}
